var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChangeLog',{attrs:{"title":_vm.inventoryItem.name,"editRoute":("/inventory/type/" + (_vm.currentType.id) + "/item/" + (_vm.inventoryItem.id)),"collection":"inventoryItems","docID":_vm.currentID}})}
var staticRenderFns = []

export { render, staticRenderFns }